var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightsDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    rx: 36,
    fill: "#F7FBFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 126,
    width: 996,
    height: 648,
    rx: 34,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 188,
    width: 348,
    height: 232,
    rx: 28,
    fill: "#132238"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 188,
    width: 504,
    height: 110,
    rx: 24,
    fill: "#EEF7FB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 326,
    width: 504,
    height: 94,
    rx: 24,
    fill: "#ECF9F4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 458,
    width: 420,
    height: 256,
    rx: 28,
    fill: "#FFF6DF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 612,
    y: 458,
    width: 434,
    height: 256,
    rx: 28,
    fill: "#F5F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210 354L270 302L322 338L386 262L446 320",
    stroke: "#5CE1D5",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212 388H446",
    stroke: "rgba(255,255,255,0.18)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M600 230H990",
    stroke: "#0F766E",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M600 264H852",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M600 364H914",
    stroke: "#132238",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M600 396H802",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M228 640V556",
    stroke: "#F59E0B",
    strokeWidth: 26,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M310 640V520",
    stroke: "#F59E0B",
    strokeWidth: 26,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M392 640V580",
    stroke: "#F59E0B",
    strokeWidth: 26,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M474 640V496",
    stroke: "#F59E0B",
    strokeWidth: 26,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 824,
    cy: 586,
    r: 86,
    stroke: "#6D57D4",
    strokeWidth: 18
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M824 500C871.496 500 910 538.504 910 586",
    stroke: "#CDBFFF",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M824 586L862 548",
    stroke: "#6D57D4",
    strokeWidth: 14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsDashboard);
export default __webpack_public_path__ + "static/media/insights-dashboard.64b25fcc047f16e876f2e99fc1866a25.svg";
export { ForwardRef as ReactComponent };